import { Component } from '@angular/core';

import { IconBase } from './icon-base';
@Component({
  selector: 'profile-circle-outline',
  imports: [],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.12 13.53C12.1 13.53 12.07 13.53 12.05 13.53C12.02 13.53 11.98 13.53 11.95 13.53C9.67998 13.46 7.97998 11.69 7.97998 9.50998C7.97998 7.28998 9.78998 5.47998 12.01 5.47998C14.23 5.47998 16.04 7.28998 16.04 9.50998C16.03 11.7 14.32 13.46 12.15 13.53C12.13 13.53 12.13 13.53 12.12 13.53ZM12 6.96998C10.6 6.96998 9.46998 8.10998 9.46998 9.49998C9.46998 10.87 10.54 11.98 11.9 12.03C11.93 12.02 12.03 12.02 12.13 12.03C13.47 11.96 14.52 10.86 14.53 9.49998C14.53 8.10998 13.4 6.96998 12 6.96998Z" />
      <path
        d="M11.9998 22.7498C9.30984 22.7498 6.73984 21.7498 4.74984 19.9298C4.56984 19.7698 4.48984 19.5298 4.50984 19.2998C4.63984 18.1098 5.37984 16.9998 6.60984 16.1798C9.58984 14.1998 14.4198 14.1998 17.3898 16.1798C18.6198 17.0098 19.3598 18.1098 19.4898 19.2998C19.5198 19.5398 19.4298 19.7698 19.2498 19.9298C17.2598 21.7498 14.6898 22.7498 11.9998 22.7498ZM6.07984 19.0998C7.73984 20.4898 9.82984 21.2498 11.9998 21.2498C14.1698 21.2498 16.2598 20.4898 17.9198 19.0998C17.7398 18.4898 17.2598 17.8998 16.5498 17.4198C14.0898 15.7798 9.91984 15.7798 7.43984 17.4198C6.72984 17.8998 6.25984 18.4898 6.07984 19.0998Z" />
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" />
    </svg>
  `,
  styles: ``,
})
export class ProfileCircleOutline extends IconBase {}
